import React from 'react'

import history from 'src/config/routes/history'
import { Button, Result } from 'src/components/Ant'

import { WrapLayout } from './styles'

export default function Error403() {
  return (
    <WrapLayout>
      <Result
        extra={
          <Button onClick={() => history.replace('/')} title="web.403.action" />
        }
        status="403"
        subTitle="web.403.sub-title"
        title="web.403.title"
      />
    </WrapLayout>
  )
}
